import { createSlice } from "@reduxjs/toolkit";
import { getReport } from "./actions/getReport";
import { getSync } from "./actions/getSync";

interface AttendanceReportState {
  getReportStatus: "idle" | "pending" | "succeeded" | "failed";
  getStatusSync: "idle" | "pending" | "succeeded" | "failed";
  reportUrl: string;
  reportSync: {
    status?: string;
    deleteDuration?: string;
    insertDuration?: string;
    totalDuration?: string;
  };
}

const initialState: AttendanceReportState = {
  getReportStatus: "idle",
  getStatusSync: "idle",
  reportUrl: "",
  reportSync: {}, // Asegúrate de que esto se mantenga cuando sea necesario
};

const attendanceReport = createSlice({
  name: "attendanceReport",
  initialState,
  reducers: {
    setInitialData(state) {
      // Solo reiniciar partes específicas del estado, mantener reportSync intacto
      state.getReportStatus = initialState.getReportStatus;
      state.getStatusSync = initialState.getStatusSync;
      state.reportUrl = initialState.reportUrl;
      // No reiniciar state.reportSync
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReport.pending, (state) => {
        state.getReportStatus = "pending";
        state.reportUrl = "";
      })
      .addCase(getReport.fulfilled, (state, { payload }) => {
        state.getReportStatus = "succeeded";
        state.reportUrl = payload;
      })
      .addCase(getReport.rejected, (state) => {
        state.getReportStatus = "failed";
        state.reportUrl = "";
      })
      .addCase(getSync.pending, (state) => {
        state.getStatusSync = "pending";
        state.reportSync = {};
      })
      .addCase(getSync.fulfilled, (state, { payload }) => {
        state.getStatusSync = "succeeded";
        state.reportSync = payload.result; // Aquí se asigna el objeto result
      })
      .addCase(getSync.rejected, (state) => {
        state.getStatusSync = "failed";
        state.reportSync = {};
      });
  },
});

export const { setInitialData } = attendanceReport.actions;

export default attendanceReport.reducer;